import { ApiClient } from "./api.ts";

export interface OrgAPIKey {
  id: string;
  organization_id: string;
  type: 'publishable' | 'secret';
  environment: string;
  name: string;
  key?: string;
  active: boolean;
  last_used_at?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateOrgAPIKeyResponse {
  org_key: OrgAPIKey;
  key?: string;
  shown_once?: boolean;
}

export class OrgAPIKeyService {
  private static instance: OrgAPIKeyService;
  private api = ApiClient.getInstance();

  private constructor() { }

  public static getInstance(): OrgAPIKeyService {
    if (!OrgAPIKeyService.instance) {
      OrgAPIKeyService.instance = new OrgAPIKeyService();
    }
    return OrgAPIKeyService.instance;
  }

  public async list(orgId: string): Promise<OrgAPIKey[]> {
    return this.api.request<OrgAPIKey[]>(`/organization/${orgId}/api-keys`) as Promise<OrgAPIKey[]>;
  }

  public async create(orgId: string, name: string, type: 'publishable' | 'secret'): Promise<CreateOrgAPIKeyResponse> {
    return this.api.request<CreateOrgAPIKeyResponse>(`/organization/${orgId}/api-keys`, {
      method: 'PUT',
      body: JSON.stringify({ name, type })
    }) as Promise<CreateOrgAPIKeyResponse>;
  }

  public async revoke(orgId: string, keyId: string): Promise<void> {
    await this.api.request<void>(`/organization/${orgId}/api-keys/${keyId}`, {
      method: 'DELETE'
    });
  }
}
